import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import SavingsOutlinedIcon from "@mui/icons-material/SavingsOutlined";
import CustomizedTimeline from "../components/CustomizedTimeline";
import AccordionComponent from "../components/Accordion";
import LandingAnalyticsSection from "../components/LandingAnalyticsSection";
import LandingTrainerSection from "../components/LandingTrainerSection";
import {
  MessengerBrandInline,
  MessengerBrandStack,
} from "../components/MessengerBrandIcons";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import "./index.css";

const AUDIENCE = {
  icon: <BusinessCenterOutlinedIcon />,
  title: "Для компаний и HR",
  desc: "Быстрее обучайте и интегрируйте сотрудников. Адаптация, продуктовые тренинги и регламенты — в привычном Telegram или MAX, без сложных LMS.",
  points: [
    "Новый сотрудник выходит на задачи быстрее",
    "Одна ссылка — для всего отдела или офиса",
    "Меньше времени наставников на повторные объяснения",
  ],
};

const BENEFITS = [
  {
    icon: <AccountTreeOutlinedIcon />,
    title: "Сценарии с выбором",
    desc: "Собирайте программу из сцен: разные маршруты для ролей, уровней подготовки или исходов ситуаций.",
  },
  {
    icon: <PlayCircleOutlineIcon />,
    title: "Видео-контент",
    desc: "Загружайте уроки прямо в редактор. Каждая сцена — видео с кнопками выбора следующего шага.",
  },
  {
    icon: <TrendingUpOutlinedIcon />,
    title: "Вовлечённость",
    desc: "Интерактив удерживает внимание: сотрудник действует, а не пассивно смотрит запись.",
  },
  {
    icon: <GroupsOutlinedIcon />,
    title: "Доступ для команды",
    desc: "Одна ссылка в Telegram или MAX — вся команда проходит сценарий без персональных ключей.",
  },
  {
    icon: <SavingsOutlinedIcon />,
    title: "Экономия времени HR",
    desc: "Готовый сценарий заменяет повторные объяснения: единый стандарт обучения для всей компании.",
  },
];

const USE_CASES = [
  {
    tag: "HR",
    title: "Адаптация новых сотрудников",
    desc: "Сценарий знакомит с компанией, продуктом и процессами — сотрудник проходит путь шаг за шагом.",
  },
  {
    tag: "Продажи",
    title: "Обучение продукту и скриптам",
    desc: "Интерактивные кейсы: как отвечать на возражения, какие шаги делать в типовых ситуациях.",
  },
  {
    tag: "Compliance",
    title: "Регламенты и инструкции",
    desc: "Сотрудник принимает решения в симуляции и видит последствия — материал запоминается лучше.",
  },
  {
    tag: "L&D",
    title: "Программы развития команд",
    desc: "Онбординг, продуктовые тренинги и внутренние стандарты — в одном интерактивном формате.",
  },
  {
    tag: "Тренажёр",
    title: "Проверка знаний после обучения",
    desc: "Вопросы с вариантами ответов, мгновенная обратная связь и отчёт по точности каждого сотрудника.",
  },
];

export default function MainPage() {
  return (
    <div className="landing landing--pattern">
      <section className="landing-hero landing-hero--mesh">
        <div className="landing-hero__content">
          <p className="landing-hero__badge">
            Корпоративное обучение в Telegram или MAX
          </p>
          <div className="landing-hero__messengers">
            <MessengerBrandInline size={34} spaced />
          </div>
          <h1 className="landing-hero__title">MOGAME</h1>
          <p className="landing-hero__subtitle">
            Создайте интерактивный сценарий обучения и запустите его для команды
            в Telegram или MAX. Без установки приложений и долгой настройки LMS.
          </p>
          <div className="landing-hero__actions">
            <Link to="/login?tab=register">
              <Button
                variant="contained"
                size="large"
                className="landing-hero__btn-primary"
              >
                Начать
              </Button>
            </Link>
            <Link to="/login">
              <Button
                variant="outlined"
                size="large"
                className="landing-hero__btn-secondary"
              >
                Войти
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <section className="landing-section landing-section--audience">
        <div className="landing-container">
          <div className="landing-section__header">
            <h2 className="landing-section__title">Кому подходит MOGAME</h2>
            <p className="landing-section__desc">
              HR, L&D и руководители отделов, которым важно быстрее обучать
              сотрудников и стандартизировать программы
            </p>
          </div>
          <div className="landing-audience landing-audience--single">
            <article className="landing-audience-card">
              <div className="landing-audience-card__icon">{AUDIENCE.icon}</div>
              <h3 className="landing-audience-card__title">{AUDIENCE.title}</h3>
              <p className="landing-audience-card__desc">{AUDIENCE.desc}</p>
              <div className="landing-audience-card__messengers">
                <MessengerBrandInline size={30} />
                <span>Обучение там, где уже общается команда</span>
              </div>
              <ul className="landing-audience-card__list">
                {AUDIENCE.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
            </article>
          </div>
        </div>
      </section>

      <section className="landing-section landing-section--benefits">
        <div className="landing-container">
          <div className="landing-section__header">
            <h2 className="landing-section__title">
              Почему интерактив работает лучше обычного видео
            </h2>
            <p className="landing-section__desc">
              Линейная запись теряет внимание на третьей минуте. Сценарий с
              выбором превращает обучение в практику
            </p>
          </div>
          <div className="landing-benefits landing-benefits--five">
            {BENEFITS.map(({ icon, title, desc }) => (
              <article className="landing-benefit-card" key={title}>
                <div className="landing-benefit-card__icon">{icon}</div>
                <h3 className="landing-benefit-card__title">{title}</h3>
                <p className="landing-benefit-card__desc">{desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="landing-section landing-section--value">
        <div className="landing-container">
          <div className="landing-section__header">
            <h2 className="landing-section__title">Какой результат вы получите</h2>
            <p className="landing-section__desc">
              Экономия времени HR и единый стандарт обучения для всей команды
            </p>
          </div>
          <div className="landing-value landing-value--single">
            <article className="landing-value-card">
              <div className="landing-value-card__icon landing-value-card__icon--corp">
                <SavingsOutlinedIcon />
              </div>
              <h3 className="landing-value-card__title">Для бизнеса</h3>
              <p className="landing-value-card__desc">
                Вы не продаёте курс — вы экономите время и деньги на обучении.
                Готовый сценарий заменяет повторные объяснения наставника: новый
                сотрудник проходит программу сам, в удобное время, в Telegram или MAX.
              </p>
              <ul className="landing-value-card__list">
                <li>Быстрее выход новичка на рабочие задачи</li>
                <li>Меньше нагрузки на HR и руководителей</li>
                <li>Единый стандарт обучения для всей команды</li>
              </ul>
            </article>
          </div>
        </div>
      </section>

      <section className="landing-section landing-section--intro">
        <div className="landing-container">
          <div className="landing-intro">
            <div className="landing-video">
              <video controls>
                <source src="/video/main.mp4" type="video/webm" />
              </video>
            </div>
            <div>
              <h2 className="landing-intro__heading">
                Как это работает: от сценария до прохождения командой
              </h2>
              <p className="landing-intro__text">
                Вы создаёте сценарий в веб-редакторе, загружаете видео-уроки и
                настраиваете переходы между сценами. Сотрудники переходят по
                ссылке и проходят программу в Telegram или MAX — смотрят ролик и выбирают
                следующий шаг.
              </p>
              <div className="landing-intro__highlights">
                <div className="landing-intro__highlight">
                  <strong>Интерактив</strong> — не PDF и не скучная запись
                </div>
                <div className="landing-intro__highlight landing-intro__highlight--messengers">
                  <span className="landing-intro__highlight-text">
                    <strong>Telegram или MAX</strong> — прохождение там, где люди уже
                    каждый день
                  </span>
                  <MessengerBrandStack size={30} />
                </div>
                <div className="landing-intro__highlight">
                  <strong>Без лишней возни</strong> — редактор, видео, ссылка
                  для команды, запуск
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="landing-section landing-section--steps">
        <div className="landing-container">
          <div className="landing-section__header">
            <h2 className="landing-section__title">
              Четыре шага до запуска программы
            </h2>
            <p className="landing-section__desc">
              От структуры сценария до доступа для команды — без программистов и
              сложных интеграций
            </p>
          </div>
          <CustomizedTimeline />
        </div>
      </section>

      <section className="landing-section landing-section--showcase">
        <div className="landing-container">
          <div className="landing-showcase">
            <div className="landing-showcase__media">
              <img
                src="/images/workspace.png"
                alt="Редактор сценария обучения"
              />
              <div className="landing-showcase__caption">
                Редактор сценария — визуальная карта программы
              </div>
            </div>
            <div className="landing-showcase__text">
              <h2 className="landing-showcase__title">Создавать это просто</h2>
              <p className="landing-showcase__desc">
                Визуальный редактор: собирайте программу обучения как карту
                сцен. Каждый блок — урок с видео и вариантами перехода дальше.
              </p>
              <ul className="landing-showcase__list">
                <li>Создавайте сцены уроков</li>
                <li>Загружайте обучающее видео</li>
                <li>Добавляйте кнопки выбора и маршруты сценария</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="landing-section landing-section--showcase-alt">
        <div className="landing-container">
          <div className="landing-showcase landing-showcase--reverse">
            <div className="landing-showcase__media">
              <img
                src="/images/project_settings.png"
                alt="Настройки сценария"
              />
              <div className="landing-showcase__caption">
                Настройки и ссылка для команды
              </div>
            </div>
            <div className="landing-showcase__text">
              <h2 className="landing-showcase__title">Простые настройки</h2>
              <p className="landing-showcase__desc">
                Минимум полей — только то, что нужно для запуска. Название,
                описание, обложка и ссылка для сотрудников.
              </p>
              <ul className="landing-showcase__list">
                <li>Название и описание программы</li>
                <li>Обложка для стартового поста в боте</li>
                <li>Групповая ссылка для всей команды</li>
                <li>Быстрый старт без технической подготовки</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <LandingTrainerSection />

      <LandingAnalyticsSection />

      <section className="landing-section landing-section--usecases">
        <div className="landing-container">
          <div className="landing-section__header">
            <h2 className="landing-section__title">Сценарии использования</h2>
            <p className="landing-section__desc">
              MOGAME для внутреннего обучения, адаптации и развития сотрудников
            </p>
          </div>
          <div className="landing-usecases">
            {USE_CASES.map(({ tag, title, desc }) => (
              <article className="landing-usecase-card" key={title}>
                <span className="landing-usecase-card__tag">{tag}</span>
                <h3 className="landing-usecase-card__title">{title}</h3>
                <p className="landing-usecase-card__desc">{desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="landing-cta">
        <h2 className="landing-cta__title">
          Запустите корпоративное обучение в Telegram или MAX
        </h2>
        <div className="landing-cta__messengers">
          <MessengerBrandInline size={36} spaced />
        </div>
        <p className="landing-cta__desc">
          Создайте сценарий, оформите подписку и поделитесь ссылкой — команда
          начнёт проходить программу уже сегодня.
        </p>
        <div className="landing-cta__actions">
          <Link to="/login?tab=register">
            <Button
              variant="contained"
              size="large"
              className="landing-hero__btn-primary"
            >
              Начать
            </Button>
          </Link>
          <Link to="/login">
            <Button
              variant="outlined"
              size="large"
              className="landing-hero__btn-secondary"
            >
              Уже есть аккаунт — войти
            </Button>
          </Link>
        </div>
      </section>

      <section className="landing-faq landing-section--faq">
        <div className="landing-container">
          <div className="landing-section__header">
            <h2 className="landing-section__title">Частые вопросы</h2>
            <p className="landing-section__desc">
              О платформе, подписке и запуске программ для команд
            </p>
          </div>
          <AccordionComponent />
        </div>
      </section>

      <div className="footer">
        <div>
          <a
            href="/oferta"
            target="_blank"
            rel="noreferrer"
            style={{ color: "white" }}
          >
            Оферта
          </a>
        </div>
      </div>
    </div>
  );
}
